import React, { useCallback, useRef, useState } from "react";
import { debounce } from "@mui/material";
import { SEARCHER_DELAY } from "../../../../search/constants";
import QrScanner from "qr-scanner";
import { QrTypes } from "../../../../qr/enums";
import EventHelper from "../../../../../common/network/helpers/event/EventHelper";
import StringUtils from "../../../../../common/utils/stringUtils";

type Props = {
  validateQrCode: (data: QrScanner.ScanResult) => Promise<void>;
  scanStatus: QrTypes;
}

export const useScannerInput = ({ validateQrCode, scanStatus }: Props) => {
  const scannerInputValue = useRef("");
  const [scannerLoading, setScannerLoading] = useState(false);

  const searchDebounceCallback = useCallback(
    debounce(e => {
      onChange(e);
    }, SEARCHER_DELAY),
    []
  );

  const getFinalScannerString = (value: string) => {
    let finalValue = value;
    const gbsCode = EventHelper.eventEdition!.gbsCode;

    const occurrences = StringUtils.countOccurrences(value, gbsCode);
    if (occurrences > 1) {
      try {
        const splitResult = value.split(`=${gbsCode}`);
        if (splitResult.length === value.length) {
          return value;
        }
        finalValue = `${value.split(`=${gbsCode}`)[0]!}=`;
      } catch(e) {
        console.error(e);
      }
    }
    return finalValue;
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (scanStatus !== QrTypes.SCANNING) {
      scannerInputValue.current = '';
      return;
    }

    scannerInputValue.current = getFinalScannerString(e.target.value);
    validateQrCode({ data: scannerInputValue.current.replaceAll("~", "|"), cornerPoints: [] });
    setScannerLoading(false);
  };

  const onScannerInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setScannerLoading(true);
    searchDebounceCallback(evt);
  };

  return { onScannerInputChange, scannerInputValue: scannerInputValue.current, scannerLoading };
}
